<template>
	<div class="m-portlet m-portlet--mobile">
		<div class="form-group m-form__group col-md-4 col-sm-12">
			<div class="input-group">
				<input v-model="username" type="text" class="form-control" placeholder="Tên tài khoản">
				<div class="input-group-append">
					<button @click="onFindUserCode" class="btn btn-brand" type="button">Tìm mã tài khoản</button>
				</div>
			</div>
		</div>
		<div v-if="usercode" class="form-group m-form__group col-md-4 col-sm-12">
			<div class="input-group m-input-group m-input-group--square">
				<div class="input-group-prepend"><span class="input-group-text" id="basic-addon1"><i class="la la-user"></i></span></div>
				<input type="text" class="form-control m-input" :value="usercode" disabled />
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data(){
			let vm = this;

	        return {
	        	"username": "",
				"usercode": null
	        }
	    },

	    methods: {
	        onFindUserCode: function(){
				if(!this.username) return;
				this.usercode = null;

	        	window.axios.get("admin-panel/tools/find-user-code/"+this.username)
        				.then((res) => {
        					if(res.data.code != 0){
        						swal("Lỗi", res.data.msg, "error");
        						return;
        					}
        					
							this.usercode = res.data.data;
        				})
        				.catch((error) => {

        				});
	        }
	    }
	}

</script>